export default __webpack_public_path__ + "static/media/institutes-logo.d8cec939.svg";